import { WhatsappIcon } from '@hugeicons/react'

import { Button } from '@/shared/ui'

import { whatsappHref } from './whatsapp'

/**
 * WhatsApp + call-to-action buttons for the premium partner profile (handoff
 * bloco 3). Side by side (both flex-1); when only one is present it takes the
 * whole row.
 *
 * Rules (requirements 1.2, 1.4, 1.5):
 * - no whatsapp → no whatsapp button
 * - no cta → no cta button
 * - cta destination "form" with no form → falls back to whatsapp; if no whatsapp, omitted
 */
export const PartnerContactActions = ({ partner, hasForm, onOpenForm }) => {
  const whatsapp = whatsappHref(partner?.meta?.whatsapp)
  const cta = partner?.meta?.cta

  let ctaButton = null
  if (cta?.label) {
    if (cta.destination === 'link' && cta.url) {
      ctaButton = (
        <Button
          href={cta.url}
          target="_blank"
          rel="noopener noreferrer"
          variant="primary"
          size="lg"
          className="flex-1"
          showTrailingIcon={false}
        >
          {cta.label}
        </Button>
      )
    } else if (cta.destination === 'form') {
      if (hasForm) {
        ctaButton = (
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="flex-1"
            onClick={onOpenForm}
            showTrailingIcon={false}
          >
            {cta.label}
          </Button>
        )
      } else if (whatsapp) {
        // Fallback to whatsapp when the form is not configured.
        ctaButton = (
          <Button
            href={whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            variant="primary"
            size="lg"
            className="flex-1"
            showTrailingIcon={false}
          >
            {cta.label}
          </Button>
        )
      }
    }
  }

  if (!whatsapp && !ctaButton) return null

  return (
    <div className="flex gap-2.5">
      {whatsapp && (
        <Button
          href={whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          variant="whatsapp"
          size="lg"
          className="flex-1 gap-2"
          leadingIcon={<WhatsappIcon size={18} variant="stroke" />}
          showTrailingIcon={false}
        >
          WhatsApp
        </Button>
      )}
      {ctaButton}
    </div>
  )
}
